import {SET_SIMULATION_LEVEL} from '../Redux.constants';

export const setSimulationLevel = (fileData) => {
  return {
    type: SET_SIMULATION_LEVEL,
    payload: fileData,
  };
};
